import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B11cPaymentTypeSubListPage } from '../b11c-payment-type-sub-list/b11c-payment-type-sub-list';
import { B11PaymentTypeManagementPage } from '../b11-payment-type-management/b11-payment-type-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B11dPaymentTypeSubListAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-b11d-payment-type-sub-list-add',
	templateUrl: 'b11d-payment-type-sub-list-add.html',
})
export class B11dPaymentTypeSubListAddPage {
	
	private todo : FormGroup;
	loading: any;
	Status: any;
	public errorMessage: any = "";
	
	paymentSubTypeData = { SUB_TYPE:'', PAYMENT_TYPE_ID:'', PAYMENT_SUB_TYPE_ACTIVE:'YES'}

	constructor(public navCtrl: NavController, public navParams: NavParams,
				private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
				public loadingCtrl: LoadingController) {
		
		this.todo = this.formBuilder.group({
			sub_type: ['', Validators.required],
			active: ['', Validators.required],
		});
		
		this.paymentSubTypeData.PAYMENT_TYPE_ID = this.navParams.get('paramPaymentId');
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad B11dPaymentTypeSubListAddPage');
	}
	
	save() {
		this.showLoader();
		this.serviceapi.insertdata("PAYMENT_SUB_TYPE",this.paymentSubTypeData).then((result) => {
			this.Status = result["Message"];
			//console.log(this.Status);
			if (this.Status == "1") {
				this.loading.dismiss();
				this.navCtrl.setRoot(B11cPaymentTypeSubListPage, {paramID: this.paymentSubTypeData.PAYMENT_TYPE_ID});
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});
	}
	
	cancel() {
		this.navCtrl.pop();
	}

	goTo() {
		this.navCtrl.setRoot(B11PaymentTypeManagementPage);
	}
	
	goTo2() {
		this.navCtrl.setRoot(B11cPaymentTypeSubListPage, {paramID: this.paymentSubTypeData.PAYMENT_TYPE_ID});
	}

	showLoader() {
		this.loading = this.loadingCtrl.create({
			content: 'Loading...',
		});
		this.loading.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/b11d-payment-type-sub-list-add/b11d-payment-type-sub-list-add.ts